export default __webpack_public_path__ + "static/media/Splenic_Flexure_Set_Up_Male_.8d2b8fb6.png";